<h2 mat-dialog-title>{{'CONFIRMACION.MODAL_CONFIRMACION.TITULO' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <div class="w100" fxLayout="column" fxLayoutAlign="start stretch">
    <h3>{{'CONFIRMACION.MODAL_CONFIRMACION.INFO_1' | translate}}</h3>
    <h3 innerHTML="{{'CONFIRMACION.MODAL_CONFIRMACION.INFO_2' | translate}}"></h3>

    <table mat-table [dataSource]="infoTabla" class="mat-elevation-z8 demo-table" *ngIf="tablaOk == true">
      <ng-container matColumnDef="clave">
        <th mat-header-cell *matHeaderCellDef class="w35">{{'CONFIRMACION.MODAL_CONFIRMACION.TABLA.TITULOS.clave' | translate}}</th>
        <td mat-cell *matCellDef="let fila"> {{'CONFIRMACION.MODAL_CONFIRMACION.TABLA.CAMPOS.' + fila.clave | translate}} </td>
      </ng-container>

      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef class="w65">{{'CONFIRMACION.MODAL_CONFIRMACION.TABLA.TITULOS.valor' | translate}}</th>
        <td mat-cell *matCellDef="let fila">
          <code *ngIf="fila.logo == undefined">{{fila.valor}}</code>
          <img *ngIf="fila.logo != undefined" [src]="fila.valor" alt="">
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="nombresColumnas"></tr>
      <tr mat-row *matRowDef="let row; columns: nombresColumnas;"></tr>
    </table>

  </div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" class="mt-20" (click)="salir()">
    {{'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SALIR' | translate}}
    <mat-icon class="ml-20">close</mat-icon>
  </button>
  <button mat-raised-button color="accent" class="mt-20 ml-20" (click)="activarEncuesta()">
    {{'CONFIRMACION.BOTONES-MODALES.ELIMINAR.VALIDAR' | translate}}
    <mat-icon class="ml-20">done</mat-icon>
  </button>
</div>
